import { cn } from '@/lib/utils'
import { useState } from 'react'
import { motion } from 'motion/react'
import clsx from 'clsx'
import { IconV2FilterOutline } from '@icons/IconV2FilterOutline'

interface CollapsibleFilterContainerProps {
  children: React.ReactNode
  className?: string
}

export function CollapsibleFilterContainer({ children, className }: CollapsibleFilterContainerProps) {
  const [open, setOpen] = useState(false)
  return (
    <div className={clsx('relative h-10 overflow-visible', { 'w-[35px]': open })}>
      <motion.div
        layout
        className={cn(
          'flex items-center rounded-md border bg-offwhite',
          {
            'absolute right-0 top-0 gap-4 pr-4 before:absolute before:inset-0 before:h-full before:w-10 before:-translate-x-[100%] before:bg-gradient-to-r before:from-transparent before:to-background before:content-[""]':
              open,
          },
          className
        )}
      >
        <motion.button
          layout
          className="flex h-10 items-center justify-center self-stretch border-r bg-muted px-2 text-muted-foreground hover:text-primary"
          onClick={() => setOpen((open) => !open)}
        >
          <IconV2FilterOutline size={20} />
        </motion.button>
        <motion.div layout className={clsx('overflow-hidden', { 'w-0': !open, 'w-full': open })}>
          {children}
        </motion.div>
      </motion.div>
    </div>
  )
}
